import axiosInstance from './api.service';
import constants from '../constants/constants';

const ENDPOINTORIGIN = 'ai/system-documents';

const list = (params) =>
  axiosInstance.get(ENDPOINTORIGIN, { ...constants.REQUIRE_INTERCEPTORS, params });

const getResource = (sourceKind, sourceDocumentId) =>
  axiosInstance.get(`${ENDPOINTORIGIN}/${sourceKind}/${sourceDocumentId}/resource`, {
    ...constants.REQUIRE_INTERCEPTORS,
    responseType: 'blob',
  });

const get = (sourceKind, sourceDocumentId) =>
  axiosInstance.get(`${ENDPOINTORIGIN}/${sourceKind}/${sourceDocumentId}`, constants.REQUIRE_INTERCEPTORS);

const index = (sourceKind, sourceDocumentId) =>
  axiosInstance.post(`${ENDPOINTORIGIN}/${sourceKind}/${sourceDocumentId}/index`, {}, constants.REQUIRE_INTERCEPTORS);

const reindex = (sourceKind, sourceDocumentId) =>
  axiosInstance.post(`${ENDPOINTORIGIN}/${sourceKind}/${sourceDocumentId}/reindex`, {}, constants.REQUIRE_INTERCEPTORS);

const retry = (sourceKind, sourceDocumentId) =>
  axiosInstance.post(`${ENDPOINTORIGIN}/${sourceKind}/${sourceDocumentId}/retry`, {}, constants.REQUIRE_INTERCEPTORS);

const removeFromAi = (sourceKind, sourceDocumentId) =>
  axiosInstance.delete(`${ENDPOINTORIGIN}/${sourceKind}/${sourceDocumentId}/index`, constants.REQUIRE_INTERCEPTORS);

export { get, getResource, index, list, reindex, removeFromAi, retry };
